import { customAlphabet } from 'nanoid';

const customId = customAlphabet('qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890', 24);

/**
 * Извлекает источник трафика из URL параметров или поддомена
 * Проверяет параметры: start, source, utm_source, ref
 * Если параметры не найдены, проверяет поддомен
 * Сохраняет результат в localStorage для избежания повторной инициализации
 * @returns {string} источник трафика или 'land' по умолчанию
 */
export const getTrafficSourceFromURL = () => {
  const STORAGE_KEY = 'ucard_traffic_source';
  const STORAGE_USER_ID_KEY = 'ucard_user_id';

  // Проверяем, есть ли уже сохраненные данные
  const savedTrafficSource = localStorage.getItem(STORAGE_KEY);
  const savedUserId = localStorage.getItem(STORAGE_USER_ID_KEY);

  if (savedTrafficSource && savedUserId) {
    // Если данные уже есть, устанавливаем их в аналитические системы и возвращаем
    try {
      if (window.gtag) {
        window.gtag('set', { user_id: savedUserId });
        console.log('GA user ID restored from localStorage:', savedUserId);
      }
    } catch (error) {
      console.error('Error setting GA user ID', error);
    }

    try {
      if (window.amplitude) {
        window.amplitude.setUserId(savedUserId);
        console.log('Amplitude user ID restored from localStorage:', savedUserId);
      }
    } catch (error) {
      console.error('Error setting Amplitude user ID', error);
    }

    return `${savedTrafficSource}_${savedUserId}`;
  }

  // Если данных нет, генерируем новые
  const urlParams = new URLSearchParams(window.location.search);
  const uniqueId = customId();

  try {
    if (window.gtag) {
      window.gtag('set', { user_id: uniqueId });
      console.log('GA user ID set to', uniqueId);
    }
  } catch (error) {
    console.error('Error setting GA user ID', error);
  }

  try {
    if (window.amplitude) {
      window.amplitude.setUserId(uniqueId);
      console.log('Amplitude user ID set to', uniqueId);
    }
  } catch (error) {
    console.error('Error setting Amplitude user ID', error);
  }

  let trafficSource;
  let trafficSourceFull;

  // Проверяем различные варианты параметров
  const paramSource = urlParams.get('start') ||
    urlParams.get('source') ||
    urlParams.get('utm_source') ||
    urlParams.get('ref');

  // Если параметр найден, используем его
  if (paramSource) {
    trafficSource = paramSource;
    trafficSourceFull = `${paramSource}_${uniqueId}`;
  } else {
    // Если параметров нет, проверяем поддомен
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Если есть поддомен (например, partner.example.com)
    if (parts.length > 2) {
      const subdomain = parts[0];
      // Исключаем стандартные поддомены
      if (subdomain !== 'www' && subdomain !== 'api' && subdomain !== 'cdn') {
        trafficSource = subdomain;
        trafficSourceFull = `${subdomain}_${uniqueId}`;
      } else {
        trafficSource = 'land';
        trafficSourceFull = `land_${uniqueId}`;
      }
    } else {
      // Возвращаем дефолтное значение
      trafficSource = 'land';
      trafficSourceFull = `land_${uniqueId}`;
    }
  }

  // Сохраняем в localStorage
  localStorage.setItem(STORAGE_KEY, trafficSource);
  localStorage.setItem(STORAGE_USER_ID_KEY, uniqueId);

  return trafficSourceFull;
};

/**
 * Генерирует ссылку на Telegram бота с нужным источником
 * @param {string} source - полная строка источника трафика в формате "source:id"
 * @returns {string} полная ссылка на бота
 */
export const getTelegramBotLink = (source = 'land') => {
  return `https://t.me/ucardonebot?start=${source}`;
};

/**
 * Очищает сохраненные данные о источнике трафика и user ID
 * Полезно для тестирования или сброса данных
 */
export const clearTrafficSourceData = () => {
  localStorage.removeItem('ucard_traffic_source');
  localStorage.removeItem('ucard_user_id');
  console.log('Traffic source data cleared from localStorage');
};
